import { Link, useNavigate } from "react-router-dom";
import React, { useEffect, useRef, useState } from "react";

import Constants from "../utils/constants";
import { useAPIs } from "../apis/APIsConfig";
import { useForm } from "../utils/hooks";
import WithLoginLayout from "../hocs/layouts/LoginLayout";
import InputMask from "react-input-mask";
import { isAffiliate, solicitudAfiliacion } from "../services/user";
import Reaptcha from "reaptcha";

const SignUp = () => {
  useAPIs();
  const navigate = useNavigate();

  var captchaRef;

  const [succeed, setSucceed] = useState(false);
  const [succeed2, setSucceed2] = useState(false);
  const [formState, setError, changeHandler, reset] = useForm({
    cedula: "",
    nombre: "",
    telefono1: "",
    telefono2: "",
    email: "",
    captcha: false,
  });

  useEffect(() => {
    setSucceed(false);
    changeHandler("captcha", false)();
    captchaRef?.reset();
  }, []);

  function disableButtonCaptcha() {
    return (
      formState.data.cedula.replaceAll("_", "").length !== 11 ||
      !formState.data.captcha
    );
  }

  function verifyAfiliado() {
    isAffiliate(formState.data.cedula).then((res) => {
      if (res && res.data.value.esAfiliado) {
        navigate(Constants.APPURLS.RECOVER_PASSWORD);
      } else {
        setSucceed(true);
      }
    });

    changeHandler("captcha", false)();
    captchaRef?.reset();
  }

  function onVerify(recaptchaResponse) {
    changeHandler("captcha", true)();
  }

  function submitForm() {
    solicitudAfiliacion(formState.data).then((res) => {
      console.info(res);
      if (res && res.data) {
        setSucceed2(true);
      }
    });
  }

  function disableButton() {
    return (
      formState.data.cedula.replaceAll("_", "").length !== 11 ||
      !formState.data.telefono1 ||
      !formState.data.nombre
    );
  }

  return (
    <>
      <Link
        to={Constants.APPURLS.LOGIN}
        className="btn btn-secondary btn-medium"
      >
        <i className="icon icon-arrow-leftv-short right"></i>Volver
      </Link>
      <div className="block pt-6 md:pt-14 pb-10">
        <h1 className="text-primary-100 font-bold mb-2">Solicitar Acceso</h1>
        <p className="text-gray-70 text-body-1 font-body font-normal">
          Para hacer la solicitud favor de llenar los siguientes campos
        </p>
      </div>

      {!succeed && (
        <form
          className="block space-y-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="form-group">
            <label>Cédula</label>
            <InputMask
              type="text"
              className="form-control large"
              placeholder="Ingresa tu documento"
              value={formState.data.cedula}
              onChange={changeHandler("cedula", undefined, "-")}
              mask="999-9999999-9"
              maskPlaceholder={"_"}
            />
          </div>
          <Reaptcha
            ref={(e) => (captchaRef = e)}
            sitekey={process.env.REACT_APP_SITE_KEY}
            onVerify={onVerify}
          />
          <button
            type="button"
            onClick={verifyAfiliado}
            disabled={disableButtonCaptcha()}
            className="btn btn-primary btn-large w-full"
          >
            Continuar
          </button>
        </form>
      )}

      {succeed && (
        <form
          className="block space-y-8"
          onSubmit={(e) => {
            e.preventDefault();
          }}
        >
          <div className="form-group">
            <label>Cédula</label>
            <InputMask
              type="text"
              disabled={true}
              className="form-control large"
              placeholder="Ingresa tu documento"
              value={formState.data.cedula}
              onChange={changeHandler("cedula", undefined, "-")}
              mask="999-9999999-9"
              maskPlaceholder={"_"}
            />
          </div>
          <div className="form-group">
            <label>Nombre completo</label>
            <input
              type="text"
              className="form-control large"
              placeholder="Nombre Apellidos"
              value={formState.data.nombre}
              onChange={changeHandler("nombre")}
            />
          </div>
          <div className="form-group">
            <label>Número de teléfono</label>
            <InputMask
              type="text"
              className="form-control large"
              placeholder="000-000-0000"
              value={formState.data.telefono1}
              onChange={changeHandler("telefono1", undefined, "-")}
              mask="999-999-9999"
              maskPlaceholder={"_"}
            />
          </div>
          <div className="form-group">
            <label>Número de teléfono secundario</label>
            <InputMask
              type="text"
              className="form-control large"
              placeholder="000-000-0000"
              value={formState.data.telefono2}
              onChange={changeHandler("telefono2", undefined, "-")}
              mask="999-999-9999"
              maskPlaceholder={"_"}
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className="form-control large"
              placeholder="ejemplo@gmail.com"
              value={formState.data.email}
              onChange={changeHandler("email")}
            />
          </div>
          <button
            type="button"
            onClick={submitForm}
            disabled={disableButton()}
            className="btn btn-primary btn-large w-full"
          >
            Solicitar Acceso
          </button>
        </form>
      )}

      {succeed2 && (
        <div className="block text-center">
          <div className="w-20 h-20 rounded-full border-2 border-primary-90 p-2 mx-auto mb-10">
            <i className="icon icon-check  rounded-full bg-primary-20 text-primary-100 text-[20px] w-full h-full flex items-center justify-center"></i>
          </div>
          <h1 className="text-primary-100 font-bold mb-2">Solicitud Enviada</h1>
          <p className="text-gray-70 text-body-1 font-body font-normal mb-12">
            Hemos recibido tu solicitud, en las próximas horas te estaremos{" "}
            <br className="hidden md:block" /> enviando un correo a tu email con
            los datos para tu ingreso.{" "}
          </p>
          <Link
            to={Constants.APPURLS.LOGIN}
            className="btn btn-primary btn-large px-4 md:px-[112px]"
          >
            Ir a Inicio de Sesión
          </Link>
        </div>
      )}
    </>
  );
};

export default WithLoginLayout(SignUp);
